import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-shipment-message',
    templateUrl: './shipment-message.component.html',
    styleUrls: ['./shipment-message.component.scss'],
    standalone: false
})
export class ShipmentMessageComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;

  constructor() { }

  ngOnInit() {
  }

}
